module.exports = __webpack_public_path__ + "static/media/logo_qr01.dcedb9b4.png";